import Headline from "./Headline";
import Logo from "./Logo";
import SeeHowItWorks from "./SeeHowItWorks";
import Subtitle from "./Subtitle";

export default function Hero() {
  return (
    <main className="hero">
      <Logo />

      <Headline />

      <Subtitle />

      <SeeHowItWorks />
    </main>
  );
}
